import React from 'react';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import { layoutClasses } from '../../config/designSystem';

const Layout = ({ children }) => {
  return (
    <div className={layoutClasses.appShell}>
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;
